<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">{{'title.document_search_receive' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <!-- Filter -->
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'enterprise_contract.ttl_search' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #myForm="ngForm" (ngSubmit)="onFilterData(0, paginate.pageSize)" class="pb-3">
          <div class="row">
            <!-- Tên/số tài liệu -->
            <div class="col-md-6 col-lg-4">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.nameOrCode = documents.nameOrCode == undefined ? '' : (documents.nameOrCode + '').trim()"
                       #focusInput matInput [placeholder]="'search_form.doc_name_or_code' | translate" name="nameOrCode"
                       [(ngModel)]="documents.nameOrCode" maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.nameOrCode" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.nameOrCode=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Email/tên khách hàng -->
            <div class="col-md-6 col-lg-4">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.customerName = documents.customerName == undefined ? '' : (documents.customerName + '').trim()"
                       matInput [placeholder]="'search_form.custommer_name_or_email' | translate" name="customerName"
                       [(ngModel)]="documents.customerName" maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.customerName" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.customerName=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Trạng thái -->
            <div class="col-md-6 col-lg-4">
              <mat-form-field class="w-100">
                <mat-label>{{'search_form.status' | translate}}</mat-label>
                <mat-select #statusSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                            (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status" name="status"
                            [(ngModel)]="documents.status" [disabled]="!myForm.valid"
                            (ngModelChange)="onClickBtnFilter()">
                  <mat-option value="null" selected (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'form.select_all' | translate}}</mat-option>
                  <mat-option [value]="enumContractStatus.PROCESSING"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.processing' | translate}}</mat-option>
                  <mat-option [value]="enumContractStatus.REJECTED"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.denied_sign' | translate}}</mat-option>
                  <mat-option [value]="enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT" *ngIf="isNotAttestedUser"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.wait_confirm_enterprice_no_moit' | translate}}</mat-option>
                  <mat-option [value]="enumContractStatus.FINISHED"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.finish' | translate}}</mat-option>
                  <!-- <mat-option [value]="enumContractStatus.CANCELLED"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.cancelled' | translate}}</mat-option> -->
                  <mat-option [value]="enumContractStatus.CONNECTING"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)"
                              *ngIf="!isNotAttestedUser">
                    {{'search_form.connecting' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Tiến độ -->
            <div class="col-md-6 col-lg-4" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <mat-label>{{'search_form.progress' | translate}}</mat-label>
                <mat-select #progressSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                            (focus)="commonService.openComboBox(checkFocus, progressSelect)" id="progressStatus"
                            name="progressStatus" [(ngModel)]="documents.progressStatus" [disabled]="!myForm.valid"
                            (ngModelChange)="onFilterData(0, paginate.pageSize)">
                  <mat-option value="null" selected (click)="this.commonService.closeDropdownList(this.progressSelect)">
                    {{'form.select_all' | translate}}</mat-option>
                  <mat-option [value]="enumContractEnterpriseStatus.WAIT_SETUP_FLOW"
                              (click)="this.commonService.closeDropdownList(this.progressSelect)">
                    {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.wait_setup_flow' |
                    translate}}
                  </mat-option>
                  <mat-option [value]="enumContractEnterpriseStatus.PROCESSING"
                              (click)="this.commonService.closeDropdownList(this.progressSelect)">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing' |
                    translate}}
                  </mat-option>
                  <mat-option [value]="enumContractEnterpriseStatus.REJECTED"
                              (click)="this.commonService.closeDropdownList(this.progressSelect)">
                    {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.denied' |
                    translate}}
                  </mat-option>
                  <mat-option [value]="enumContractEnterpriseStatus.SIGNED"
                              (click)="this.commonService.closeDropdownList(this.progressSelect)">
                    {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.signed' |
                    translate}}
                  </mat-option>
                  <mat-option [value]="0" (click)="this.commonService.closeDropdownList(this.progressSelect)">
                    {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress' |
                    translate}}
                  </mat-option>
                  <mat-option [value]="enumContractEnterpriseStatus.DAEMON_PROCESSING"
                              (click)="this.commonService.closeDropdownList(this.progressSelect)">
                    {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.daemon_processing' |
                    translate}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <!-- Tên chủ thể lập -->
            <div class="col-md-6 col-lg-4" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.createdEnterpriseName = documents.createdEnterpriseName == undefined ? '' : (documents.createdEnterpriseName + '').trim()"
                       matInput [placeholder]="'search_form.created_enteprise' | translate" name="createdEnterpriseName"
                       [(ngModel)]="documents.createdEnterpriseName" maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.createdEnterpriseName" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.createdEnterpriseName=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <!-- <div *ngIf="isDocumentManager && !isBasicSearchForm" class="col-lg-4 col-md-6">
              <mat-form-field class="w-100">
                <input
                  (focusout)="documents.createdEnterpriseName = documents.createdEnterpriseName == undefined ? '' : (documents.createdEnterpriseName + '').trim()"
                  matInput [placeholder]="'Tên chủ thể lập'"
                  [(ngModel)]="documents.createdEnterpriseName" maxlength="200" autocomplete="off">
              </mat-form-field>
            </div> -->

            <!-- Thời gian nhận (từ ngày) -->
            <div class="col-lg-2 col-md-4" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <mat-label>{{ 'search_form.received_date_from' | translate }}</mat-label>
                <input matInput [matDatepicker]="receivedTimeFrom" #receivedTimeFromCtrl="ngModel"
                       (focus)="receivedDateErr = 'fromDate'"
                       (change)="this.commonService.resetDatePicker(pickerInput.value, this.ngForm.controls['receivedTimeFrom'])"
                       name="receivedTimeFrom" #pickerInput [(ngModel)]="documents.receivedTimeFrom" maxlength="200"
                       [max]="documents.receivedTimeTo" autocomplete="off"/>
                <mat-datepicker-toggle matSuffix [for]="receivedTimeFrom">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                     [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #receivedTimeFrom></mat-datepicker>
                <mat-error *ngIf="receivedTimeFromCtrl?.errors?.matDatepickerParse">
                  {{'validation.format_of_date' | translate}}
                </mat-error>
                <mat-error *ngIf="receivedTimeFromCtrl?.errors?.matDatepickerMax && receivedDateErr == 'fromDate'">
                  {{ 'search_form.received_date_from' | translate }}
                  {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
                  {{ 'search_form.received_date_to' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Thời gian nhận (đến ngày) -->
            <div class="col-lg-2 col-md-4" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <mat-label>{{ 'search_form.received_date_to' | translate }}</mat-label>
                <input matInput [matDatepicker]="receivedTimeToRef" [min]="documents.receivedTimeFrom"
                       (focus)="receivedDateErr = 'toDate'"
                       (change)="this.commonService.resetDatePicker(pickerInput1.value, this.ngForm.controls['receivedTimeTo'])"
                       name="receivedTimeTo" #pickerInput1 [(ngModel)]="documents.receivedTimeTo"
                       #receivedTimeToCtrl="ngModel" maxlength="200" autocomplete="off"/>
                <mat-datepicker-toggle matSuffix [for]="receivedTimeToRef">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                     [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #receivedTimeToRef></mat-datepicker>
                <mat-error *ngIf="receivedTimeToCtrl?.errors?.matDatepickerParse">
                  {{'validation.format_of_date' | translate}}
                </mat-error>
                <mat-error *ngIf="receivedTimeToCtrl?.errors?.matDatepickerMin && receivedDateErr == 'toDate'">
                  {{ 'search_form.received_date_to' | translate }}
                  {{ 'validation.to_date_larger_than_or_equal_from_date' | translate }}
                  {{ 'search_form.received_date_from' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Vai trò ký -->
            <div class="col-md-6 col-lg-4" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <mat-label>{{'search_form.user_role_title' | translate}}</mat-label>
                <mat-select #signRoleSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                            (focus)="commonService.openComboBox(checkFocus, signRoleSelect)" id="signRole"
                            name="signRole"
                            [(ngModel)]="documents.signRole" (ngModelChange)="signRoleChanged($event)">
                  <mat-option value="null" selected (click)="this.commonService.closeDropdownList(this.signRoleSelect)">
                    {{'search_form.user_role' | translate}}</mat-option>
                  <mat-option [value]="enumContractUserRole.SIGN"
                              (click)="this.commonService.closeDropdownList(this.signRoleSelect)">
                    {{'search_form.sign_doc' | translate}}</mat-option>
                  <mat-option [value]="enumContractUserRole.APPROVE"
                              (click)="this.commonService.closeDropdownList(this.signRoleSelect)">
                    {{'search_form.approve_doc' | translate}}</mat-option>
                  <mat-option [value]="enumContractUserRole.INITIAL"
                              (click)="this.commonService.closeDropdownList(this.signRoleSelect)">
                    {{'search_form.initial_doc' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Email/tên/số điện thoại -->
            <div class="col-md-6 col-lg-4" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.nameOrEmailOrPhoneUserSign = documents.nameOrEmailOrPhoneUserSign == undefined ? '' : (documents.nameOrEmailOrPhoneUserSign + '').trim()"
                       matInput [placeholder]="'search_form.name_phome_email_process' | translate"
                       name="nameOrEmailOrPhoneUserSign" #nameOrEmailOrPhoneUserSign="ngModel"
                       [(ngModel)]="documents.nameOrEmailOrPhoneUserSign" maxlength="200" autocomplete="off"
                       [disabled]="isDisableNamePhoneEmail" required>
                <button mat-button *ngIf="documents.nameOrEmailOrPhoneUserSign" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.nameOrEmailOrPhoneUserSign=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="nameOrEmailOrPhoneUserSign.invalid && nameOrEmailOrPhoneUserSign?.errors?.required">
                  {{'validation.name_phone_email_user_sign_require' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Thời gian lập (từ ngày) -->
            <!-- <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <mat-label>{{ 'search_form.created_date_from' | translate }}</mat-label>
                <input matInput [matDatepicker]="createdTimeFrom" [max]="documents.createdTimeTo"
                       #createdTimeFromCtrl="ngModel"
                       (change)="this.commonService.resetDatePicker(pickerInput.value, this.ngForm.controls['createdTimeFrom'])"
                       name="createdTimeFrom" #pickerInput [(ngModel)]="documents.createdTimeFrom" maxlength="200"
                       (focus)="createdDateErr = 'fromDate'" autocomplete="off"/>
                <mat-datepicker-toggle matSuffix [for]="createdTimeFrom">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true" [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #createdTimeFrom></mat-datepicker>
                <mat-error *ngIf="createdTimeFromCtrl?.errors?.matDatepickerParse">
                  {{'validation.format_of_date' | translate}}
                </mat-error>
                <mat-error *ngIf="createdTimeFromCtrl?.errors?.matDatepickerMax && createdDateErr == 'fromDate'">
                  {{ 'search_form.created_date_from' | translate }}
                  {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
                  {{ 'search_form.created_date_to' | translate }}
                </mat-error>
              </mat-form-field>
            </div> -->

            <!-- Thời gian lập (đến ngày) -->
            <!-- <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <mat-label>{{ 'search_form.created_date_to' | translate }}</mat-label>
                <input matInput [matDatepicker]="createdTimeToRef" [min]="documents.createdTimeFrom"
                       (change)="this.commonService.resetDatePicker(pickerInput1.value, this.ngForm.controls['createdTimeTo'])"
                       name="createdTimeTo" #pickerInput1 [(ngModel)]="documents.createdTimeTo"
                       #createdTimeToCtrl="ngModel"
                       maxlength="200" (focus)="createdDateErr = 'toDate'" autocomplete="off"/>
                <mat-datepicker-toggle matSuffix [for]="createdTimeToRef">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true" [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #createdTimeToRef></mat-datepicker>
                <mat-error *ngIf="createdTimeToCtrl?.errors?.matDatepickerParse">
                  {{'validation.format_of_date' | translate}}
                </mat-error>
                <mat-error *ngIf="createdTimeToCtrl?.errors?.matDatepickerMin && createdDateErr == 'toDate'">
                  {{ 'search_form.created_date_to' | translate }}
                  {{ 'validation.to_date_larger_than_or_equal_from_date' | translate }}
                  {{ 'search_form.created_date_from' | translate }}
                </mat-error>
              </mat-form-field>
            </div> -->

            <!-- button up/down -->
            <div class="col-lg-12 col-md-6 d-flex justify-content-end">
              <button *ngIf="!isBasicSearchForm" type="button" mat-button class="advance-search"
                      (click)="onCloseAdvancedSearchForm()">
                <span>{{'enterprise_contract.buttons.basic' | translate}}</span>
                <em class="material-icons">keyboard_arrow_up</em>
              </button>
              <button *ngIf="isBasicSearchForm" type="button" mat-button class="advance-search"
                      (click)="onExpandAdvancedSearchForm()">
                <span>{{'enterprise_contract.buttons.advance' | translate}}</span>
                <em class="material-icons">keyboard_arrow_down</em>
              </button>
            </div>
          </div>

          <!-- button tìm kiếm -->
          <div class="row mt-3">
            <div class="col-lg-12 d-flex justify-content-center">
              <button mat-stroked-button color="primary" type="submit" (click)="onClickBtnFilter()"
                      [disabled]="!myForm.valid || isTableLoading">
                <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                {{'enterprise_contract.buttons.search' | translate}}
              </button>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center list-title">
          <span>{{'enterprise_contract.list_document_recieve' | translate}} ({{paginate.totalRow}}
            ), {{'enterprise_contract.selected_title' | translate}}: {{selection.selected.length}}</span>

          <div class="d-flex align-items-center">
            <button class="pull-right list-btn mr-2" mat-stroked-button color="primary" type="button" [disabled]="selection.selected.length === 0" (click)="setupSignFlowLot()">
              <mat-icon class="mr-0">device_hub</mat-icon>
              {{'button.setupSignFlowLot' | translate}}
            </button>
            <button class="pull-right list-btn" mat-stroked-button color="primary" type="button" [disabled]="selection.selected.length === 0" (click)="multiDownload()">
              <mat-icon class="mr-0">save_alt</mat-icon>
              {{'button.downloadContract' | translate}}
            </button>
          </div>
        </mat-panel-title>

        <div *ngIf="isProcess" class="d-flex align-items-center progress-sign-banner">
          <span class="progress-sign-text mr-3">{{'messages.signing_multi_progress' | translate}}
            {{percent}} %</span>
          <mat-progress-bar class="progress-sign-bar" mode="determinate" [value]="percent"
                            style="flex: 1; max-width: 300px; margin-right: 8px"></mat-progress-bar>
          <button mat-icon-button color="primary" type="button" matTooltip="{{'button.viewDetail' | translate}}"
                  (click)="openSignFlowView()">
            <mat-icon>play_circle_outline</mat-icon>
          </button>
        </div>

        <div class="mat-table-container">
          <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">
            <!-- select -->
            <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                <mat-checkbox
                  *ngIf="dataSource && dataSource.data && dataSource.data.value && dataSource.data.value.length > 0"
                  (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  color="primary"></mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                        (click)="$event.stopPropagation()">
                <mat-checkbox
                  color="primary"
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(element.id) : null"
                  [checked]="selection.isSelected(element.id)"
                >
                </mat-checkbox>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell check-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- STT -->
            <ng-container matColumnDef="STT">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.No' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                        (click)="$event.stopPropagation()">
                {{element.STT}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Tài liệu Column -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 20%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.document_code_name' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="width: 20%;">
                <!-- <button *ngIf="element.hasChildren == 1" (click)="expandedParent(element.id)" mat-icon-button
                        color="primary" style="margin-left: -10px;">
                  <mat-icon id="expand_more" [matTooltip]="'enterprise_contract.tooltips.btn_expand_more' | translate"
                            #expand_more *ngIf="!element.close">add
                  </mat-icon>
                  <mat-icon id="expand_less" [matTooltip]="'enterprise_contract.tooltips.btn_expand_less' | translate"
                            #expand_less *ngIf="element.close">remove
                  </mat-icon>
                </button> -->
                <span (click)="$event.stopPropagation()" matTooltip="{{element.name}}" class="fix-width"
                      style="margin-left: -5px;">
                  {{element.name}}
                </span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 20%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Các bên ký hợp đồng Column -->
            <ng-container matColumnDef="allName">
              <mat-header-cell *matHeaderCellDef style="max-width: 100%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.contract_parties' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allName }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="max-width: 100%;">
                <span class="fix-width">{{ element.allName }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 100%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Email các bên ký hợp đồng Column -->
            <ng-container matColumnDef="allEmail">
              <mat-header-cell *matHeaderCellDef style="max-width: 20%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.contract_parties_email' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allEmail }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="max-width: 20%;">
                <span class="fix-width">{{ element.allEmail }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 20%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Trạng thái Column -->
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                               style="max-width: 11%;">
                {{'enterprise_contract.table_headers.document_status' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                        style="max-width: 11%;" (click)="$event.stopPropagation()">
                <nz-tag *ngIf="element.status === enumContractStatus.PROCESSING" [nzColor]="'blue'"
                        style="margin-right: 0px;">
                  {{'search_form.processing' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status === enumContractStatus.REJECTED" [nzColor]="'red'"
                        style="margin-right: 0px;">
                  {{'search_form.denied_sign' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status === enumContractStatus.FINISHED && element.contractTerminationStatus != 2 && element.contractTerminationStatus != 4" [nzColor]="'green'"
                        style="margin-right: 0px;">
                  {{'search_form.finish' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status === enumContractStatus.CANCELLED" [nzColor]="'red'"
                        style="margin-right: 0px;">
                  {{'search_form.cancelled' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status === enumContractStatus.CONNECTING" [nzColor]="'blue'"
                        style="margin-right: 0px;">
                  {{'search_form.connecting' | translate}}</nz-tag>
                <nz-tag class='wait-confirm-enterprice-no-moit__tag' *ngIf="element.status === 9">
                  {{'search_form.wait_confirm_enterprice_no_moit' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status == 4 && element.contractTerminationStatus == 2"    
                        [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'contract_terminate.terminating' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status == 4 && element.contractTerminationStatus == 4"
                        [nzColor]="'green'"
                        style="margin-right: 0px;">{{'contract_terminate.terminated' | translate}}</nz-tag>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell doc-status-col" style="max-width: 11%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
              <!-- <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                style="max-width: 11%;" (click)="$event.stopPropagation()" [matTooltip]="
                   element.status === enumContractStatus.REJECTED ? ('search_form.denied_sign' | translate)
                  : element.status === enumContractStatus.PROCESSING ? ('search_form.processing' | translate)
                  : element.status === enumContractStatus.FINISHED ? ('search_form.finish' | translate)
                  : ''">
                <nz-tag *ngIf="element.status === enumContractStatus.PROCESSING" [nzColor]="'blue'">
                  {{'search_form.processing' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status === enumContractStatus.REJECTED" [nzColor]="'red'">
                  {{'search_form.denied_sign' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status === enumContractStatus.FINISHED" [nzColor]="'green'">
                  {{'search_form.finish' | translate}}</nz-tag>
              </mat-cell> -->
            </ng-container>

            <!-- Lý do từ chối  -->
            <ng-container matColumnDef="statusOriginatorReason">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                               style="max-width: 12%;">
                {{'searchDocumentMine.lbl_reason_reject' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom"
                        [matTooltip]="(element.cancelReason || element.rejectReason || '')"
                        style="max-width: 12%;" (click)="$event.stopPropagation()">
                <span class="fix-width">{{ element.cancelReason || element.rejectReason }}</span>
              </mat-cell>
            </ng-container>

            <!-- Tiến độ Column -->
            <ng-container matColumnDef="progressStatus">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                               style="max-width: 11%;">
                {{'enterprise_contract.table_headers.enterprise_progress' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                        style="max-width: 11%;" (click)="$event.stopPropagation()">
                <nz-tag
                  *ngIf="element.progressStatus === enumContractEnterpriseStatus.PROCESSING && element.status != enumContractStatus.REJECTED "
                  [nzColor]="'blue'" style="margin-right: 0px;">
                  {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing' |
                  translate}}
                </nz-tag>
                <nz-tag
                  *ngIf="element.progressStatus === enumContractEnterpriseStatus.PROCESSING && element.status === enumContractStatus.REJECTED "
                  style="margin-right: 0px;">
                  {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress' |
                  translate}}
                </nz-tag>
                <nz-tag *ngIf="element.progressStatus === enumContractEnterpriseStatus.REJECTED" [nzColor]="'red'"
                        style="margin-right: 0px;">
                  {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.denied' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.progressStatus === enumContractEnterpriseStatus.SIGNED" [nzColor]="'green'"
                        style="margin-right: 0px;">
                  {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.signed' | translate}}
                </nz-tag>
                <nz-tag
                  *ngIf="element.progressStatus === enumContractEnterpriseStatus.WAIT_SETUP_FLOW && element.status != enumContractStatus.REJECTED"
                  [nzColor]="'orange'" style="margin-right: 0px;">
                  {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.wait_setup_flow' |
                  translate}}
                </nz-tag>
                <nz-tag
                  *ngIf="element.progressStatus === enumContractEnterpriseStatus.WAIT_SETUP_FLOW && element.status === enumContractStatus.REJECTED"
                  style="margin-right: 0px;">
                  {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress' |
                  translate}}
                </nz-tag>
                <nz-tag
                  *ngIf="element.progressStatus === enumContractEnterpriseStatus.DAEMON_PROCESSING && element.status != enumContractStatus.REJECTED "
                  style="margin-right: 0px;">
                  {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.daemon_processing' |
                  translate}}
                </nz-tag>

              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell doc-status-col" style="max-width: 11%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
              <!-- <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                style="max-width: 11%;" (click)="$event.stopPropagation()" [matTooltip]="
                   (element.progressStatus === enumContractEnterpriseStatus.PROCESSING && element.status != enumContractStatus.REJECTED) ? ('enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing' | translate)
                  : (element.progressStatus === enumContractEnterpriseStatus.PROCESSING && element.status === enumContractStatus.REJECTED) ? ('enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress' | translate)
                  : element.progressStatus === enumContractEnterpriseStatus.REJECTED ? ('enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.denied' | translate)
                  : element.progressStatus === enumContractEnterpriseStatus.SIGNED ? ('enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.signed' | translate)
                  : (element.progressStatus === enumContractEnterpriseStatus.WAIT_SETUP_FLOW && element.status != enumContractStatus.REJECTED) ? ('enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.wait_setup_flow' | translate)
                  : (element.progressStatus === enumContractEnterpriseStatus.WAIT_SETUP_FLOW && element.status === enumContractStatus.REJECTED) ? ('enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress' | translate)
                  : ''">
                <nz-tag
                  *ngIf="element.progressStatus === enumContractEnterpriseStatus.PROCESSING && element.status != enumContractStatus.REJECTED "
                  [nzColor]="'blue'">
                  {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing' | translate}}
                </nz-tag>
                <nz-tag
                  *ngIf="element.progressStatus === enumContractEnterpriseStatus.PROCESSING && element.status === enumContractStatus.REJECTED ">
                  {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.progressStatus === enumContractEnterpriseStatus.REJECTED" [nzColor]="'red'">
                  {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.denied' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.progressStatus === enumContractEnterpriseStatus.SIGNED" [nzColor]="'green'">
                  {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.signed' | translate}}
                </nz-tag>
                <nz-tag
                  *ngIf="element.progressStatus === enumContractEnterpriseStatus.WAIT_SETUP_FLOW && element.status != enumContractStatus.REJECTED"
                  [nzColor]="'orange'">
                  {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.wait_setup_flow' | translate}}
                </nz-tag>
                <nz-tag
                  *ngIf="element.progressStatus === enumContractEnterpriseStatus.WAIT_SETUP_FLOW && element.status === enumContractStatus.REJECTED">
                  {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress' | translate}}
                </nz-tag>
              </mat-cell> -->
            </ng-container>

            <!-- bên lập -->
            <ng-container matColumnDef="createdEnterpriseName">
              <mat-header-cell *matHeaderCellDef style="max-width: 13%;" mat-sort-header
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                <span>
                  {{'enterprise_contract.table_headers.created_enterprise' | translate}}
                </span>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.createdEnterpriseName }}"
                        (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom"
                        style="max-width: 13%;">
                <span class="fix-width">{{ element.createdEnterpriseName }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 13%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Thời gian lập Column -->
            <ng-container matColumnDef="receivedTime">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="max-width: 10%;">
                {{'headertable.received_time' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                        [matTooltip]="element.receivedTime | dateformat"
                        (click)="$event.stopPropagation()" style="max-width: 10%;">
                <span class="fix-width">{{ element.receivedTime | dateformat}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 10%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- người thực hiện -->
            <ng-container matColumnDef="userSign">
              <mat-header-cell *matHeaderCellDef style="max-width: 13%;" mat-sort-header
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                <span>
                  {{'enterprise_contract.table_headers.user_sign' | translate}}
                </span>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.userSign }}" (click)="$event.stopPropagation()"
                        class="mat-cell-non-boder-right-bottom" style="max-width: 13%;">
                <span class="fix-width">{{ element.userSign }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 13%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- vai trò -->
            <ng-container matColumnDef="role">
              <mat-header-cell *matHeaderCellDef style="max-width: 6%;" mat-sort-header
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                <span>
                  {{'enterprise_contract.table_headers.role' | translate}}
                </span>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        matTooltip="{{ (element.role === 1 ? 'search_form.sign_doc' : (element.role === 2 ? 'search_form.approve_doc' : (element.role === 3 ? 'search_form.initial_doc' : ''))) | translate}}"
                        (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom"
                        style="max-width: 6%;">
                <span *ngIf="element.role === 1" class="fix-width">{{'search_form.sign_doc' | translate}}</span>
                <span *ngIf="element.role === 2" class="fix-width">{{'search_form.approve_doc' | translate}}</span>
                <span *ngIf="element.role === 3" class="fix-width">{{'search_form.initial_doc' | translate}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 6%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="formType">
              <mat-header-cell *matHeaderCellDef
                              class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="width: 150px;">
                {{'contract_terminate.form_type' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                        [matTooltip]="getFormType(element.formType)"
                        style="width: 150px;">
                <span class="fix-width">{{ getFormType(element.formType) }}<span class="test-deploy-cicd"></span></span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="width: 150px;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!--action col-->
            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center"
                               [ngStyle]="{'max-width': this.mediaBreakpoint === SCREEN_SIZE.SM ? '17%' : '8%'}">
                {{'headertable.action' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="number-cell-center" (click)="$event.stopPropagation()"
                        [ngStyle]="{'max-width': this.mediaBreakpoint === SCREEN_SIZE.SM ? '17%' : '8%'}">
                <button mat-icon-button (click)="viewDetail(element,element.id)" >
                  <mat-icon matTooltip="{{'enterprise_contract.tooltips.document_view' | translate}}">
                    visibility
                  </mat-icon>
                </button>
                <button mat-icon-button (click)="openPDFByBrowser(element)">
                  <mat-icon matTooltip="{{'enterprise_contract.buttons.download' | translate}}">save_alt
                  </mat-icon>
                </button>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center"
                               [ngStyle]="{'max-width': this.mediaBreakpoint === SCREEN_SIZE.SM ? '17%' : '8%'}">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- hang skeleton trong bang: mat-footer-row render doc lap voi data nen ton tai
                 ca khi bang chua co du lieu; moi cot co mat-footer-cell rieng theo dung cot; an/hien qua class theo isTableLoading -->
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row">
            </mat-row>
            <mat-footer-row *matFooterRowDef="displayedColumns"
            class="table-skeleton-row"
            [class.table-skeleton-hidden]="!isTableLoading"></mat-footer-row>
          </mat-table>
          </div>


        <!-- Pagination -->
        <app-pagination [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)"
                        [isShowNoRecord]="!isTableLoading">
        </app-pagination>
      </mat-expansion-panel>
    </mat-accordion>


  </mat-card-content>
</mat-card>
